import React from 'react';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';
import { Full } from '../../layout/Full/Full';
import { RelativeCenter } from '../../layout/RelativeCenter/RelativeCenter';
import { TextCustom } from '../../ui/TextCustom';
import IconComponent from '../IconComponents/IconComponent';

interface IErrorNotificationProps {
    error: string;
    text: string;
    textSize: number;
    icon?: React.ReactNode;
    direction?: "v" | "h";
    size?: number;
    iconName?: string;
}

export const ErrorNotification: React.FC<IErrorNotificationProps> = ({direction = "h", size = 2, error, text, textSize, iconName = 'NOT_OK' }) => {
    return (
        <Full>
            <RelativeCenter>
                <FlexCenter  direction={direction}>
                    <IconComponent size={size} iconName={iconName}/>

                    <FlexCenter gap={0}>
                        <TextCustom color="dark" size={textSize} align="center">
                            {error}
                        </TextCustom>
                        <TextCustom color="dark" size={textSize} weight={500}>
                            {text}
                        </TextCustom>
                    </FlexCenter>
                </FlexCenter>
            </RelativeCenter>
        </Full>
    );
};
